<app-personalized-dialog [loading]="loading">
    <div dialog-title>Edit Benefit Rule</div>
    
    <div dialog-content>
        <div class="form-container">
            <!-- Service Dropdown -->
            <div class="row">
                <div class="col-12 mb-3">
                    <label class="label">Service <span class="label-required" aria-hidden="true">*</span></label>
                    <select 
                        class="form-control form-select" 
                        [formControl]="benefitServiceControl"
                        [class.is-invalid]="benefitServiceControl.invalid && benefitServiceControl.touched">
                        <option value="" disabled>Select a service...</option>
                        <option *ngFor="let service of services" [value]="service._id">
                            {{ service.name }} ({{ service.code }})
                        </option>
                    </select>
                    <div *ngIf="loadingServices" class="text-muted mt-1">
                        <i class="fa fa-spinner fa-spin"></i> Loading services...
                    </div>
                    <div *ngIf="benefitServiceControl.invalid && benefitServiceControl.touched" class="text-danger" style="font-size: 10.5px;">
                        *This field is required
                    </div>
                </div>
            </div>

            <div class="row">
                <!-- Trap Quantity -->
                <div class="col-md-4 mb-3">
                    <app-custom-input 
                        label="Trap Quantity (≥)"
                        type="number"
                        placeholder="0"
                        [control]="trapQuantityControl">
                    </app-custom-input>
                </div>

                <!-- Capacity -->
                <div class="col-md-4 mb-3">
                    <app-custom-input 
                        label="Capacity (GL) (≥)"
                        type="number"
                        placeholder="0"
                        [control]="capacityControl">
                    </app-custom-input>
                </div>

                <!-- Restaurant Count -->
                <div class="col-md-4 mb-3">
                    <app-custom-input 
                        label="Restaurants (≥)"
                        type="number"
                        placeholder="0"
                        [control]="restaurantCountControl">
                    </app-custom-input>
                </div>
            </div>

            <div class="row">
                <!-- Description -->
                <div class="col-12 mb-3">
                    <app-custom-input 
                        label="Description (Optional)"
                        type="text"
                        placeholder="Optional description for this rule"
                        [control]="descriptionControl">
                    </app-custom-input>
                </div>
            </div>
        </div>
    </div>

    <div dialog-actions class="w-100">
        <div class="d-flex justify-content-end gap-2 w-100">
            <app-button 
                type="button" 
                minWidth="120px" 
                variant="primary" 
                [loading]="loading"
                [disabled]="ruleForm.invalid || loadingServices"
                (onClick)="onSubmit()">
                Update Rule
            </app-button>
            <app-button 
                type="button" 
                minWidth="120px" 
                variant="secondary" 
                (onClick)="close()">
                Cancel
            </app-button>
        </div>
    </div>
</app-personalized-dialog>
